// import Context from './context'
import { map, kebabCase, isFunction, isUndefined, assign } from 'lodash'
import * as Directives from './directives'
import { Builder } from './common'
const plugins = {
    tween: () => require('animation.gsap'),
    indicators: () => require('debug.addIndicators'),
    velocity: () => require('animation.velocity')
}
const plugin = {
    install (Vue, option) {
        option = assign({}, { indicators: true }, option)
        Vue.SCROLLMAGIC_DEBUG = isUndefined(option.debug) ? process.env.VUE_APP_V_SCROLL_MAGIC_DEBUG === 'true' : option.debug
        // Vue.vScrollMagic = Vue.prototype.$vScrollMagic = Context.getInstance()
        map(option, (v, k) => {
            v && plugins[k] && plugins[k].apply(this)
        })
        map({ ...Directives }, (v, k) => {
            return Vue.directive(kebabCase('scrollmagic' + k), isFunction(v) ? v() : v)
        })
        const api = {
            getController: Builder.getController,
            getScene: Builder.getScene,
            debug: Vue.SCROLLMAGIC_DEBUG
        }
        Vue.vScrollMagicApi = Vue.prototype.$vscrollmagicApi = Vue.prototype.$vScrollMagicApi = api
    }
}
// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin)
}

export default plugin
const version = '__VERSION__'
export {
    version
}
